import { EnvironmentProviders } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { createPlatformTheme, defaultPlatformTheme } from './theme.config';
import type { PlatformConfig } from '@platform/config';

/**
 * Provides PrimeNG configuration with platform theme
 * Automatically uses theme configuration from platform config
 * 
 * @param platformConfig - Platform configuration containing theme settings.
 *                         If not provided, uses default theme.
 * @returns EnvironmentProviders for PrimeNG configuration
 * 
 * @example
 * ```typescript
 * // Merge config first, then provide UI
 * const mergedConfig = deepMerge({ ...defaultConfig }, environment);
 * 
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     providePlatformConfig(environment),
 *     providePlatformTheme(mergedConfig),
 *     // ... other providers
 *   ],
 * };
 * ```
 */
export function providePlatformTheme(platformConfig?: PlatformConfig): EnvironmentProviders {
  // Create theme based on platform config
  const theme = platformConfig ? createPlatformTheme(platformConfig) : defaultPlatformTheme;

  return providePrimeNG({
    theme: {
      preset: theme,
      options: {
        darkModeSelector: '.app-dark',
      },
    },
    ripple: true,
  });
}

